import map from 'lodash/map'
import * as React from 'react'
import {H2, H3} from '@frontrow/console/src/components/typography'
import {mmap} from '@freckle/maybe'
import {type CsvFileErrorT} from '@frontrow/console/src/entities/models/roster-sync'

type Props = {
  errors: Array<CsvFileErrorT>
}

export default function CsvFileErrors({errors}: Props): React.ReactElement {
  if (errors.length) {
    const errorElems = map(errors, (fileErrors, i: number) => {
      const errorList = map(fileErrors.errors, (error, j: number) => (
        <li key={j}>
          <p>
            {mmap(RowNumber, error.rowNumber)}
            {error.message}
            {mmap(FirstSeenOn, error.rowNumberFirstSeen)}
          </p>
        </li>
      ))
      return (
        <React.Fragment key={i}>
          <H3>{fileErrors.csvFileName}</H3>
          <ul>{errorList}</ul>
        </React.Fragment>
      )
    })
    return (
      <React.Fragment>
        <H2>Please fix the errors below and re-upload the CSVs.</H2>
        {errorElems}
      </React.Fragment>
    )
  } else {
    return <></>
  }
}

function RowNumber(i: number): React.ReactElement {
  return (
    <React.Fragment>
      Row: {i} <br />
    </React.Fragment>
  )
}

function FirstSeenOn(i: number): React.ReactElement {
  return (
    <React.Fragment>
      <br />
      First Seen On Row: {i}
    </React.Fragment>
  )
}
